import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  Divider,
  Heading,
  useDialogContainer,
  TextField,
  Flex,
} from "@adobe/react-spectrum";
import React, { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import PropTypes from "prop-types";
import {
  error as ErrorToast,
  success as SuccessToast,
} from "@react/react-spectrum/Toast";
import { workflowApi } from "../../../../api/workflowApi";
import useUserProfile from "../../../../context/user-context";

export default function RevertPendingDeleteSubDialog({
  rowInfo,
  refreshTable,
  isPageLoading,
  setPageLoading,
}) {
  const { user } = useUserProfile();
  const { authState } = useOktaAuth();

  const [rejectionReason, setRejectionReason] = useState("");

  const dialog = useDialogContainer();

  const handleApprove = () => {
    setPageLoading(true);
    workflowApi
      .rejectWorkflows(
        {
          workflow_id_list: [rowInfo?.wf_id],
          rejection_reason: rejectionReason,
          user_id: user?.userId,
        },
        authState.accessToken
      )
      .then((data) => {
        setPageLoading(false);
        const successfulApprovals = [];
        const unsuccessfulApprovals = [];

        Object.keys(data).forEach((wf) => {
          if (data[wf]) successfulApprovals.push(wf);
          else unsuccessfulApprovals.push(wf);
        });
        if (successfulApprovals.length > 0) {
          dialog.dismiss();
          refreshTable();
          SuccessToast(
            `Successfully reverted ${rowInfo.sub_name} (${rowInfo.sub_id}) back to the ${rowInfo?.old_status} state!`,
            {
              timeout: 5000,
            }
          );
        }
      })
      .catch((error) => {
        console.log("error");
        dialog.dismiss();
        setPageLoading(false);
        ErrorToast(
          error.response?.data?.message ||
            `Failed to revert status of ${rowInfo.sub_name} (${rowInfo.sub_id}) back to ${rowInfo?.old_status}`,
          {
            timeout: 5000,
          }
        );
      });
  };

  const handleCancel = () => {
    dialog.dismiss();
  };

  return (
    <Dialog>
      <Heading>{`Revert ${rowInfo.parent ? "Parent" : "Sub"}: ${
        rowInfo.sub_name
      } (${rowInfo.sub_id})`}</Heading>
      <Divider />
      <Content>
        <Flex marginBottom="15px">
          {`Reverting the deletion will move the company back to the previous status (${rowInfo?.old_status}). Proceed to revert?`}
        </Flex>
        <TextField
          label="Comment"
          width="100%"
          onChange={(val) => setRejectionReason(val)}
          marginTop="10px"
        />
      </Content>
      <ButtonGroup>
        <Button onPress={handleCancel} variant="secondary">
          Cancel
        </Button>
        <Button
          onPress={handleApprove}
          color="primary"
          variant="accent"
          isDisabled={isPageLoading}
        >
          Revert
        </Button>
      </ButtonGroup>
    </Dialog>
  );
}

RevertPendingDeleteSubDialog.propTypes = {
  rowInfo: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ])
  ).isRequired,
  refreshTable: PropTypes.func.isRequired,
  setPageLoading: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
};
